"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var ButtonGroup = function (props) {
    var gap = props.gap, rest = __rest(props, ["gap"]);
    var classes = classNames('button-group', { 'button-group--no-gap': gap === false }, props.className);
    return (React.createElement("div", __assign({ role: "group", className: classes }, rest), props.children));
};
exports.default = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/ButtonGroup/ButtonGroup.js
// module id = 209
// module chunks = 0